<template>
	<router-link tag="a" to="/sells-history" class="position-card" v-ripple>
		<div class="trophy-icon" :class="top == 15 ? 'bg-success' : top == 70 ? 'bg-warning' : 'bg-danger'"></div>
		<div class="p-1 flex-grow-1 ml-2">
			<div class="label">PUNTOS</div>
			<h1 class="score m-0">
				<strong>{{ points }}</strong>
			</h1>
		</div>

		<!-- <div class="p-1 flex-grow-1 text-center">
			<div class="label">RANKING</div>
			<h1 class="score m-0">
				<strong>{{ top }}</strong>
			</h1>
		</div> -->
	</router-link>
</template>

<script>
import gql from 'graphql-tag'
export default {
	data() {
		return {
			loading: true,
			points: 0,
			top: 0,
		}
	},
	beforeMount() {
		this.loading = false
		this.load()
	},

	methods: {
		load() {
			this.$apollo
				.query({
					query: gql`
						query {
							sellerLogged {
								id
								name
								points
								top
							}
						}
					`,
					fetchPolicy: 'no-cache',
				})
				.then(({ data }) => {
					this.points = data.sellerLogged.points
					this.top = data.sellerLogged.top
					this.loading = false
				})
		},
	},
}
</script>

<style scoped>
.position-card {
	border-radius: 12px;
	background-color: #fff;
	width: 100%;
	max-width: 480px;
	margin: 16px auto;
	display: flex;
	align-items: center;
}
.trophy-icon {
	width: 72px;
	height: 72px;
	border-radius: 40px;
	margin: -14px 7px;
	flex-shrink: 0;
	background-image: url('~@/assets/img/top.png');
	background-size: cover;
	background-position: center;
}
.label {
	font-family: 'LGSmartSemiBold', sans-serif;
	font-size: 11px;
	text-transform: uppercase;
	font-weight: 600;
	line-height: 16px;
	color: #6f6f6f;
}
.score {
	line-height: 30px;
	color: #000;
	font-size: 24pt;
}

.progress {
	width: 100%;
	height: 6px;
	background-color: #f3f3f3;
	border-radius: 4px;
	margin-top: 6px;
	position: relative;
}

.progress:before {
	content: '';
	height: 6px;
	width: 48%;
	border-radius: 4px;
	position: absolute;
	left: 0px;
	top: 0px;
	background-color: #a50034;
}
</style>
